import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Input, Button, PageHeader, Textarea, Alert } from "../../../components/";
import { EndPoints } from "../../../api";
import { useFormik } from 'formik'
import { ContactSupportValidator } from "./contactSupportValidator";
import { Prevbutton } from "../../../assets/images";
import { localStoreName } from "../../../utils/constants";
import {
  contactButtonWrapper,
  contactPrevbuttonWrapper,
  contactSupportWrapper,
  contactInputWrapper,
  contactInputWrapper1,
} from "./contactSupport.module.css";

const ContactSupprt = () => {
  const [alert, setAlert] = useState("")
  const localS = JSON.parse(localStorage.getItem(localStoreName))
  const token = localS?.token
  axios.defaults.headers.common['x-auth-token'] = token;

  
  // useEffect(() => {
    const handleOnSubmit = () => {
       axios
              .post(EndPoints.contactSupport, values)
              .then((res) => {
                if (res.data.success) {
                  setAlert("success")
                  setTimeout(()=> {
                    history.push("/login");
                  }, 3000)
                }
              })
              .catch((err) => {
                setAlert("failure")
              });
          };
        // }, [])
      
  const { errors, values, handleChange, handleSubmit, touched } = useFormik({
    initialValues : {
      firstname: "",
      lastname: "",
      email: "",
      phone_number: "",
      message: ""
    },
    validationSchema: ContactSupportValidator,
    onSubmit: handleOnSubmit
  })


  const history = useHistory();
  return (
    <div style={{width: "100%"}}>
      {
        alert==="success"?  
         <div style={{margin: "auto", width: "100%"}}>
        <Alert 
              success
              labelText="Your Message haas been sent successfully!"
              status="Success"
              type="Contact support"
              onClick={()=>setAlert("")}
            />
        </div>
        :
        alert==="failure"?
        <div style={{margin: "auto", width: "100%"}}>
        <Alert 
            failure
            status="Failure"
            labelText="Opps! Something went wrong"
            type="Contact Message"
            onClick={()=>setAlert("")}
          />
        </div>
        :
        <></>
      }
      <form className={contactSupportWrapper} onSubmit={handleSubmit}>
        <div className={contactPrevbuttonWrapper}>
          <img
            src={Prevbutton}
            onClick={() => history.push("/")}
            alt="Previous Icon"
          />
        </div>
        <PageHeader
          head="Contact support"
          text="Our support team is always available and ready to assist you for an awesome experience"
        />

        <div className={contactInputWrapper}>
          <Input
            type="text"
            placeholder="Enter first name"
            label="First name"
            name="firstname"
            value={values.firstname}
            onChange={handleChange}
            errorText={touched.firstname? errors.firstname : ""}
        
          />
          <Input
            type="text"
            placeholder="Enter last name"
            label="Last name"
            name="lastname"
            value={values.lastname}
            onChange={handleChange}
            errorText={touched.lastname? errors.lastname : ""}
          />
        </div>
        <div className={contactInputWrapper1}>
          <Input
            type="text"
            placeholder="Enter email address"
            label="Email address"
            name="email"
            value={values.email}
            onChange={handleChange}
            errorText={touched.email? errors.email : ""}
          />
          <Input
            type="text"
            placeholder="Enter mobile number"
            label="Mobile number"
            name="phone_number"
            value={values.phone_number}
            onChange={handleChange}
            errorText={touched.phone_number? errors.phone_number: ""}
          />
        </div>
        <div className={contactInputWrapper}>
          <Textarea
            textareaLabel="Let us know your thoughts, Issues, blocker or setbacks"
            rows="5"
            textareaText="Let us know your thoughts, Issues, blocker or setbacks"
            name="message"
            value={values.message}
            onChange={handleChange}
            errorText={errors.message}
          />
        </div>
        <div className={contactButtonWrapper}>
          <Button buttonName="Send message" main="fill" type="submit" />
        </div>
      </form>
      </div>
  );
};
export { ContactSupprt };
